import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';
import { PageContainer, ContainerButton } from '../../../../styles/styles';

function SalvarRascunho() {
    const successTitle = 'Rascunho salvo com sucesso!';
    const successMessage = [
        [
            'Quando quiser, volte ao formulário para continuar preenchendo os dados, acessando a opção ',
            <Link to="/movimentacao_cadastral/movimentacoes_pendentes">
                <u>Movimentações pendentes.</u>
            </Link>,
        ],
    ];

    const history = useHistory();

    return (
        <PageContainer>
            <Alert type={3} title={successTitle} message={successMessage} />

            <ContainerButton>
                <Button id="continueStep" type="primary" onClick={() => history.push('/')}>
                    Acessar home
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default SalvarRascunho;
